var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckInactiveImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 128,
    viewBox: "0 0 182 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7632 123.098H55.8569V123.212H67.7632V123.098Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7734 121.861H0V121.976H24.7734V121.861Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3983 127.336H43.3462V127.451H55.3983V127.336Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.008 126.569H94.2266V126.684H112.008V126.569Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.977 126.569H116.082V126.684H120.977V126.569Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.999 124.644H157.015V124.759H181.999V124.644Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9319 16.6802H62.8174C63.5059 16.6802 64.1663 16.9527 64.6531 17.4378C65.14 17.9229 65.4135 18.5808 65.4135 19.2668V118.755H26.3491V19.2628C26.3502 18.5798 26.6223 17.9249 27.1062 17.4411C27.5901 16.9572 28.2464 16.6837 28.9319 16.6802Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6182 22.712H29.5811V33.8854H34.6182V22.712Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.167 22.712H57.1299V33.8854H62.167V22.712Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7988 22.712H38.7617V33.8854H43.7988V22.712Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9876 22.712H47.9504V33.8854H52.9876V22.712Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6182 40.3495H29.5811V51.5228H34.6182V40.3495Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.167 40.3495H57.1299V51.5228H62.167V40.3495Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7988 40.3495H38.7617V51.5228H43.7988V40.3495Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9876 40.3495H47.9504V51.5228H52.9876V40.3495Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6182 57.9882H29.5811V69.1615H34.6182V57.9882Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.167 57.9882H57.1299V69.1615H62.167V57.9882Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7988 57.9882H38.7617V69.1615H43.7988V57.9882Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9876 57.9882H47.9504V69.1615H52.9876V57.9882Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6182 75.6268H29.5811V86.8002H34.6182V75.6268Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.167 75.6268H57.1299V86.8002H62.167V75.6268Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7988 75.6268H38.7617V86.8002H43.7988V75.6268Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9876 75.6268H47.9504V86.8002H52.9876V75.6268Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6182 93.2642H29.5811V104.437H34.6182V93.2642Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.167 93.2642H57.1299V104.437H62.167V93.2642Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7988 93.2642H38.7617V104.437H43.7988V93.2642Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9876 93.2642H47.9504V104.437H52.9876V93.2642Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.071 25.9559H173.34C173.9 25.9559 174.437 26.1775 174.832 26.5718C175.228 26.9661 175.451 27.5009 175.451 28.0586V118.756H146.984V28.0639C146.983 27.5093 147.201 26.9768 147.592 26.582C147.983 26.1873 148.515 25.9623 149.071 25.9559Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.171 31.4399H150.592V41.5959H155.171V31.4399Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.517 31.4399H158.938V41.5959H163.517V31.4399Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.867 31.4399H167.287V41.5959H171.867V31.4399Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.171 47.4761H150.592V57.6321H155.171V47.4761Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.517 47.4761H158.938V57.6321H163.517V47.4761Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.867 47.4761H167.287V57.6321H171.867V47.4761Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.171 63.5135H150.592V73.6695H155.171V63.5135Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.517 63.5135H158.938V73.6695H163.517V63.5135Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.867 63.5135H167.287V73.6695H171.867V63.5135Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.171 79.5454H150.592V89.7014H155.171V79.5454Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.517 79.5454H158.938V89.7014H163.517V79.5454Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.867 79.5454H167.287V89.7014H171.867V79.5454Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.171 95.5829H150.592V105.739H155.171V95.5829Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.517 95.5829H158.938V105.739H163.517V95.5829Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.867 95.5829H167.287V105.739H171.867V95.5829Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.474 0.00012207H132.896C133.696 0.00012207 134.464 0.316898 135.03 0.880758C135.596 1.44462 135.913 2.20937 135.913 3.00679V118.755H90.4563V3.00679C90.4563 2.20937 90.7742 1.44462 91.3402 0.880758C91.9061 0.316898 92.6737 0.00012207 93.474 0.00012207Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.091 7.01746H94.2292V20.0161H100.091V7.01746Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.142 7.01746H126.28V20.0161H132.142V7.01746Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.776 7.01746H104.914V20.0161H110.776V7.01746Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.457 7.01746H115.595V20.0161H121.457V7.01746Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.091 27.5386H94.2292V40.5372H100.091V27.5386Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.142 27.5386H126.28V40.5372H132.142V27.5386Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.776 27.5386H104.914V40.5372H110.776V27.5386Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.457 27.5386H115.595V40.5372H121.457V27.5386Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.091 48.0601H94.2292V61.0587H100.091V48.0601Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.142 48.0601H126.28V61.0587H132.142V48.0601Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.776 48.0601H104.914V61.0587H110.776V48.0601Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.457 48.0601H115.595V61.0587H121.457V48.0601Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.091 68.5812H94.2292V81.5798H100.091V68.5812Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.142 68.5812H126.28V81.5798H132.142V68.5812Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.776 68.5812H104.914V81.5798H110.776V68.5812Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.457 68.5812H115.595V81.5798H121.457V68.5812Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.091 89.0988H94.2292V102.097H100.091V89.0988Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.142 89.0988H126.28V102.097H132.142V89.0988Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.776 89.0988H104.914V102.097H110.776V89.0988Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.457 89.0988H115.595V102.097H121.457V89.0988Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4578 42.5308H65.4141V118.755H90.4578V42.5308Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.982 50.6935H135.918V118.755H146.982V50.6935Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3362 118.755H4.41992V86.9321L26.3362 79.5454V118.755Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4581 123.389C139.493 123.389 179.243 121.077 179.243 118.225C179.243 115.373 139.493 113.061 90.4581 113.061C41.4234 113.061 1.67285 115.373 1.67285 118.225C1.67285 121.077 41.4234 123.389 90.4581 123.389Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7333 99.2415C64.1358 99.2415 61.6447 100.27 59.808 102.099C57.9713 103.929 56.9395 106.411 56.9395 108.999C56.9395 111.587 57.9713 114.069 59.808 115.899C61.6447 117.729 64.1358 118.757 66.7333 118.757H68.6938V99.2415H66.7333Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.081 99.2415C135.484 99.2415 132.993 100.27 131.156 102.099C129.319 103.929 128.288 106.411 128.288 108.999C128.288 111.587 129.319 114.069 131.156 115.899C132.993 117.729 135.484 118.757 138.081 118.757H140.037V99.2415H138.081Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.754 118.751C111.161 118.751 115.544 114.383 115.544 108.996C115.544 103.609 111.161 99.2415 105.754 99.2415C100.347 99.2415 95.9631 103.609 95.9631 108.996C95.9631 114.383 100.347 118.751 105.754 118.751Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4001 118.751C39.8073 118.751 44.1907 114.383 44.1907 108.996C44.1907 103.609 39.8073 99.2415 34.4001 99.2415C28.993 99.2415 24.6096 103.609 24.6096 108.996C24.6096 114.383 28.993 118.751 34.4001 118.751Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.386 57.2815H79.2351V104.311H116.386V57.2815Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.386 57.2815H79.2351V104.311H116.386V57.2815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.886 68.9749L153.538 69.2708L155.018 70.9995L155.366 70.7036L153.886 68.9749Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86 61.9189L147.512 62.2148L152.12 67.5988L152.469 67.3029L147.86 61.9189Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.386 104.304H162.528V83.8975C162.529 82.3821 161.987 80.9164 160.999 79.7642L146.644 62.9562C145.122 61.1762 143.23 59.7467 141.099 58.7667C138.968 57.7867 136.649 57.2795 134.302 57.2802H116.386V104.304Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.946 81.9588V64.6668C123.946 64.2944 124.019 63.9256 124.162 63.5816C124.306 63.2376 124.515 62.9251 124.78 62.6619C125.044 62.3988 125.358 62.1902 125.704 62.048C126.049 61.9059 126.42 61.833 126.793 61.8335H131.21C133.523 61.8344 135.808 62.3355 137.908 63.3024C140.008 64.2692 141.872 65.6787 143.371 67.4335L154.228 80.1255C154.664 80.6346 154.904 81.2816 154.906 81.9508C154.906 82.7026 154.606 83.4237 154.073 83.9557C153.54 84.4877 152.816 84.7871 152.062 84.7881H126.793C126.04 84.7881 125.318 84.4911 124.784 83.9618C124.251 83.4326 123.949 82.7143 123.946 81.9642V81.9588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.526 98.7481H156.827C156.519 98.7479 156.217 98.6676 155.95 98.5151C155.683 98.3625 155.46 98.1431 155.304 97.8785C155.148 97.614 155.064 97.3134 155.061 97.0066C155.057 96.6999 155.134 96.3975 155.284 96.1295L156.247 94.4135C156.399 94.1381 156.622 93.9083 156.893 93.748C157.165 93.5876 157.474 93.5025 157.79 93.5015H162.524L162.526 98.7481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.185 49.3788H18.3923V104.305H108.185V49.3788Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.185 49.3788H18.3923V104.305H108.185V49.3788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.9881 95.9335H42.7068V99.2415H57.9881V95.9335Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.5864 95.9335H18.3923V99.2415H22.5864V95.9335Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.4113 49.3788H18.3923V104.305H49.4113V49.3788Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.33 49.3788H31.8308V104.305H32.33V49.3788Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.812 104.305H19.1042C18.0481 104.305 17.1919 105.158 17.1919 106.21C17.1919 107.262 18.0481 108.115 19.1042 108.115H161.812C162.868 108.115 163.725 107.262 163.725 106.21C163.725 105.158 162.868 104.305 161.812 104.305Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.047 118.751C145.455 118.751 149.838 114.383 149.838 108.996C149.838 103.609 145.455 99.2415 140.047 99.2415C134.64 99.2415 130.257 103.609 130.257 108.996C130.257 114.383 134.64 118.751 140.047 118.751Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.046 115.272C143.526 115.272 146.346 112.462 146.346 108.995C146.346 105.528 143.526 102.717 140.046 102.717C136.566 102.717 133.746 105.528 133.746 108.995C133.746 112.462 136.566 115.272 140.046 115.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6938 118.751C74.101 118.751 78.4844 114.383 78.4844 108.996C78.4844 103.609 74.101 99.2415 68.6938 99.2415C63.2867 99.2415 58.9033 103.609 58.9033 108.996C58.9033 114.383 63.2867 118.751 68.6938 118.751Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.694 115.272C72.1736 115.272 74.9944 112.462 74.9944 108.995C74.9944 105.528 72.1736 102.717 68.694 102.717C65.2143 102.717 62.3936 105.528 62.3936 108.995C62.3936 112.462 65.2143 115.272 68.694 115.272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckInactiveImg);
export default __webpack_public_path__ + "static/media/truckInactiveImg.60e3490bb298c93f87a22b2cc72c7419.svg";
export { ForwardRef as ReactComponent };